import { render, staticRenderFns } from "./CategoryMenu.vue?vue&type=template&id=023b3dc6&scoped=true&"
import script from "./CategoryMenu.vue?vue&type=script&lang=js&"
export * from "./CategoryMenu.vue?vue&type=script&lang=js&"
import style0 from "./CategoryMenu.vue?vue&type=style&index=0&id=023b3dc6&lang=scss&scoped=true&"
import style1 from "./CategoryMenu.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "023b3dc6",
  null
  
)

export default component.exports